<template>
  <span
    class="rmr-soft-badge"
    :class="`rmr-soft-badge--${size}`"
    :style="badgeStyle"
    :title="title || label"
  >
    <img
      v-if="iconSrc"
      class="rmr-soft-badge__img"
      :src="iconSrc"
      alt=""
      @error="onIconError"
    />
    <v-icon
      v-else-if="icon"
      class="rmr-soft-badge__icon"
      :size="iconSize"
      :color="color"
    >
      {{ icon }}
    </v-icon>
    <span class="rmr-soft-badge__label">{{ label }}</span>
  </span>
</template>

<script>
import { RMR_SURFACE_2, RMR_TEXT_SUBTLE } from "@/styles/tokens";

export default {
  name: "RmrSoftBadge",
  props: {
    label: {
      type: String,
      required: true,
    },
    // Text color (hex). Defaults to the muted token.
    color: {
      type: String,
      default: RMR_TEXT_SUBTLE,
    },
    // Soft background color (hex).
    background: {
      type: String,
      default: RMR_SURFACE_2,
    },
    // SVG path from @mdi/js (Vuetify runs in mdiSvg mode).
    icon: {
      type: String,
      default: "",
    },
    // Raster icon (e.g. /icons/sources/*.png). Takes precedence over `icon`.
    iconSrc: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "sm",
      validator: (value) => ["xs", "sm"].includes(value),
    },
  },
  computed: {
    badgeStyle() {
      return {
        color: this.color,
        backgroundColor: this.background,
      };
    },
    iconSize() {
      return this.size === "xs" ? 11 : 13;
    },
  },
  methods: {
    // A missing source icon must not leave a broken-image glyph in the badge.
    onIconError(event) {
      event.target.style.display = "none";
    },
  },
};
</script>

<style lang="scss" scoped>
.rmr-soft-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: $rmr-radius-pill;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  max-width: 100%;
}

.rmr-soft-badge__label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.rmr-soft-badge__img {
  flex-shrink: 0;
  object-fit: contain;
  border-radius: 2px;
}

.rmr-soft-badge__icon {
  flex-shrink: 0;
}

.rmr-soft-badge--sm {
  font-size: 11px;
  padding: 3px 9px;

  .rmr-soft-badge__img {
    width: 12px;
    height: 12px;
  }
}

.rmr-soft-badge--xs {
  font-size: 10px;
  padding: 2px 7px;

  .rmr-soft-badge__img {
    width: 10px;
    height: 10px;
  }
}
</style>
